export default {
  DARK: {
    name: 'dark',
    codemirror: 'monokai'
  },
  LIGHT: {
    name: 'light', 
    codemirror: 'eclipse'
  }
};
